import React, { Component } from 'react';
import { Field, reduxForm, Form, change } from 'redux-form';
import Button from 'material-ui/Button';
import { MenuItem } from 'material-ui/Menu';
import Paper from 'material-ui/Paper';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';

import Layout from '../Layout';

import renderTextField from '../../helpers/RenderTextFiled';
import renderSelectField from '../../helpers/RenderSelectField';
import validationHelper from '../../helpers/ValidationHelper';

const styles = theme => ({
    card: {
      display: 'flex',
      boxShadow: 'none',
      justifyContent: 'center'
    },
    content: {
      display: 'flex'
    },
    paperStyle: {
        width: '70%',
        height: '70%',
        display: 'inline-block',
        margin: 20,
        marginTop: '13vh'
    },
    buttonStyle: {
        marginTop: 10,
        marginBottom: 15
    },
    browseButtonStyle: {
        height: '10%',
        marginLeft: 20
    },
    marginStyle: {
        margin: 8
    },
    textField: {
        width: 200,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    headerStyle: {
        position: 'relative',
        width: '100%',
        height: '60px',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
    },
    headerTitleStyle: {
        flexDirection: 'column',
        margin: '2%',
        fontSize: '24px',
        fontFamily: 'Roboto'
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    none: {
         display: 'none'
    },
    marginTop3: {
        marginTop: '3%'
    }
});

const validate = (values) => {
    const errors = validationHelper.validateRequired(['fileName', 'selectReport', 'referenceNumber'], values);
    return errors;
};

class BatchSubmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
          file:null
        };
      }

    handleSave = (event) => {
        console.log(event);
        console.log(this.state.file);
    }

    handleChange = (event) => {
        this.setState({ file:event.target.files[0] }, () => {
            this.props.dispatch(change('BatchSubmissionForm', 'fileName', this.state.file.name));
        });
    }

    render() {
        const { classes, handleSubmit } = this.props;
        return (
            <Layout className="App" showMenu menuTitle="Account Settings" leftTitle="Report Manager" rightTitle="Submit File" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727." >
                <Paper className={classes.paperStyle}>
                    <Form onSubmit={handleSubmit(this.handleSave)}>
                        <Card className={classes.card}>
                            <CardContent className={[classes.content, classes.marginTop3]}>
                                <input
                                    accept="*"
                                    className={classes.none}
                                    id="raised-button-file"
                                    multiple
                                    type="file"
                                    onChange={this.handleChange}
                                />
                                <Field name="fileName" component={renderTextField} label="" className={[classes.textField, classes.marginStyle]} />
                                <label htmlFor="raised-button-file">
                                    <Button variant="raised" component="span" color="primary" className={classes.browseButtonStyle}>
                                        Upload
                                    </Button>
                                </label>
                            </CardContent>
                        </Card>
                        <Card className={classes.card}>
                            <CardContent className={classes.content}>
                                <Field name="selectReport" component={renderSelectField} label="Select a Report" className={classes.textField} divClassName={classes.formControl} >
                                    <MenuItem value={1}>Report 1</MenuItem>
                                    <MenuItem value={2}>Report 2</MenuItem>
                                    <MenuItem value={3}>Report 3</MenuItem>
                                </Field>
                                <Field name="referenceNumber" component={renderTextField} label="Reference Number" className={[classes.textField, classes.marginStyle]} />
                            </CardContent>
                        </Card>
                        <div className={classes.buttonStyle}>
                            <Button variant="raised" color="primary" type="submit">Submit</Button>
                        </div>
                    </Form>
                </Paper>
            </Layout>
        );
    }
}

BatchSubmission.propTypes = {
    classes: PropTypes.shape().isRequired
};

export default withStyles(styles, { withTheme: true })(reduxForm({ form: 'BatchSubmissionForm', validate })(BatchSubmission));


// WEBPACK FOOTER //
// ./src/components/Account/BatchSubmission.js